<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_TrialBalanceCheck')"
    :close-on-click-modal="false"
  >
    <div style="text-align: center;">
      <div style="margin: 10px 10px 10px 10px;height: 300px">
        <span :style="'margin: 20px 0 60px 0;'+msgLabelStyle">{{ msgLabel }}</span>
        <el-table
          :data="[data]"
          border
          :header-cell-style="{ 'height': '80px','text-align': 'center' }"
          :cell-style="{ 'height': '80px','text-align': 'center' }"
        >
          <el-table-column prop="item" :label="$t('CargoMsg.Cargo_Item')" width="180" />
          <el-table-column prop="debit" :label="$t('CargoMsg.Cargo_DebitAmountCN')" width="180" />
          <el-table-column prop="credt" :label="$t('CargoMsg.Cargo_CreditAmountCN')" width="180" />
          <el-table-column prop="balance" :label="$t('CargoMsg.Cargo_Difference')" width="180" />
        </el-table>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import * as accountTitleBalanceApi from '@/api/financeManage/accountTitleBalance'

export default {
  name: 'BalanceValidateDialog',
  props: {
    visible: { type: Boolean, required: true },
    accountSet: { type: Object, default: null },
    fiscalPeriod: { type: Object, default: null }
  },
  data() {
    return {
      innerVisible: false,
      data: {
        item: this.$t('CargoMsg.Cargo_OBCILC'),
        debit: '',
        credt: '',
        balance: ''
      },
      msgLabel: '',
      msgLabelStyle: ''
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (newVal) {
        this.search()
      }
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    search() {
      const object = {}
      object.accountSetUuid = this.accountSet.uuid
      object.initialPeriod = 1
      accountTitleBalanceApi.loadAccountTitleBalance(object).then(resp => {
        this.loadAccountTitleBalanceHandler(resp)
      })
    },
    loadAccountTitleBalanceHandler(resp) {
      if (!resp.data) return
      let debit = 0.0
      let credit = 0.0
      for (const item of resp.data) {
        if (item.level === 1) {
          if (item.debitCrebit) {
            debit += Number(item['beginningBalance'])
          } else {
            credit += Number(item['beginningBalance'])
          }
        }
      }
      this.data.debit = Number(debit).toFixed(2)
      this.data.credt = Number(credit).toFixed(2)
      this.msgLabelStyle = ''
      if (Number(debit).toFixed(2) !== Number(credit).toFixed(2)) {
        this.msgLabel = this.$t('CargoMsg.Cargo_TIBYEIUPDCTBSAIS')
        this.msgLabelStyle = 'color: red'
      } else {
        this.msgLabel = this.$t('CargoMsg.Cargo_TIBYEIB')
        this.msgLabelStyle = 'color: red'
      }
      this.data.balance = Number(debit - credit).toFixed(2)
    }
  }
}
</script>

<style scoped>

</style>
